import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "params-section" }
const _hoisted_2 = { class: "field-group params-section__body" }
const _hoisted_3 = {
  key: 0,
  class: "params-row__title"
}
const _hoisted_4 = { class: "params-row__title-text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "params-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!
  const _component_parameter_inline = _resolveComponent("parameter-inline")!
  const _component_parameter_expand_modal = _resolveComponent("parameter-expand-modal")!
  const _component_confirm_action_popup = _resolveComponent("confirm-action-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mosta_context_menu, {
      visible: _ctx.addMenuOpen,
      position: _ctx.menuPos,
      "min-width": 280,
      resizable: "",
      "default-width": 320,
      "default-height": 360,
      "max-width": 480,
      "min-height": 240,
      "menu-class": "params-add-menu-ctx",
      "close-on-esc": "",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:addMenuOpen', false))),
      onContentResize: _ctx.refitAddMenu
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "params-add-menu",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_ctx.addMenuOpen)
            ? (_openBlock(), _createBlock(_component_aux_selector, {
                key: 0,
                class: "params-add-menu__selector",
                "model-type": _ctx.parameterTemplatesType,
                "set-id": _ctx.entityId,
                "preferred-segment": _ctx.attachmentType,
                "allow-multiple": false,
                "limit-height-to-container": "",
                "container-height-px": _ctx.templateListHeight,
                modelValue: _ctx.templatePick,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.templatePick) = $event)),
                  _ctx.onTemplatePicked
                ],
                onSelectorClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:addMenuOpen', false)))
              }, null, 8, ["model-type", "set-id", "preferred-segment", "container-height-px", "modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "position", "onContentResize"]),
    (_ctx.refreshing)
      ? (_openBlock(), _createBlock(_component_app_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instances, (container, pid) => {
        return (_openBlock(), _createElementBlock("div", {
          key: _ctx.containerKey(container),
          class: _normalizeClass(["params-item", { 'params-item--record': _ctx.isComplexRow(container) }])
        }, [
          (_ctx.showRowTitle(container))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(container.Instance?.Name), 1),
                (_ctx.canEdit && _ctx.isRemovable(container))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "params-title-action",
                      onClick: ($event: any) => (_ctx.onTitleAction({ action: 'refresh' }, container))
                    }, [
                      _createVNode(_component_app_tooltip, {
                        text: _ctx.$t('param_action_refresh')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(_component_app_icon, {
                            name: "refresh",
                            width: "14px",
                            color: "currentColor",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (_ctx.canEdit && _ctx.isRemovable(container))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "params-title-action",
                      onClick: ($event: any) => (_ctx.onTitleAction({ action: 'remove' }, container, $event))
                    }, [
                      _createVNode(_component_app_tooltip, {
                        text: _ctx.$t('param_action_delete')
                      }, {
                        activator: _withCtx(() => [
                          _createVNode(_component_app_icon, {
                            name: "delete-outline",
                            width: "14px",
                            color: "currentColor",
                            "hover-color": "#D05A4F",
                            cursor: "pointer"
                          })
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["params-row__value", {
              'params-row__value--flat': !_ctx.isComplexRow(container),
              'params-row__value--single': _ctx.isSingleValueRow(container),
            }])
            }, [
              _createElementVNode("table", {
                class: "dialog-table",
                ref_for: true,
                ref: 
                (el) => {
                  _ctx.triggerEls[pid] = el;
                }
              
              }, [
                (_ctx.triggerEls[pid])
                  ? (_openBlock(), _createBlock(_component_parameter_inline, {
                      key: 0,
                      "is-root": true,
                      editable: _ctx.canEdit,
                      "is-table": "",
                      "backspace-moves-to-prev-field": false,
                      "show-clear-icon": false,
                      id: 'entity-param-' + _ctx.containerKey(container),
                      modelValue: _ctx.parameters_model[pid],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.parameters_model[pid]) = $event),
                      "token-styles": _ctx.tokenStyles,
                      "show-custom": false,
                      "value-set-from-instance": true,
                      "context-trigger": _ctx.triggerEls[pid],
                      "create-mode": false,
                      "show-field-label": _ctx.showFieldLabelFor(container),
                      onTitleAction: ($event: any) => (_ctx.onTitleAction($event, container))
                    }, null, 8, ["editable", "id", "modelValue", "onUpdate:modelValue", "token-styles", "context-trigger", "show-field-label", "onTitleAction"]))
                  : _createCommentVNode("", true)
              ], 512)
            ], 2)
          ])
        ], 2))
      }), 128))
    ]),
    (_ctx.expandedContainer)
      ? (_openBlock(), _createBlock(_component_parameter_expand_modal, {
          key: 1,
          ref: "expandModal",
          id: 'entity-param-full-' + _ctx.containerKey(_ctx.expandedContainer),
          title: _ctx.expandedTitle,
          editable: _ctx.canEdit,
          "token-styles": _ctx.tokenStyles,
          "show-field-label": _ctx.showFieldLabelFor(_ctx.expandedContainer),
          "model-value": _ctx.parameters_model[_ctx.expandedIndex],
          loading: _ctx.refreshing,
          "onUpdate:modelValue": _ctx.onExpandedModelUpdate,
          onRefresh: _ctx.refresh
        }, null, 8, ["id", "title", "editable", "token-styles", "show-field-label", "model-value", "loading", "onUpdate:modelValue", "onRefresh"]))
      : _createCommentVNode("", true),
    (_ctx.confirmRemoveOpen)
      ? (_openBlock(), _createBlock(_component_confirm_action_popup, {
          key: 2,
          title: _ctx.$t('confirm_delete_parameter_title'),
          question: "",
          "question-html": _ctx.confirmRemoveQuestionHtml,
          position: _ctx.confirmRemovePos,
          onConfirm: _ctx.confirmRemove,
          onCancel: _ctx.closeConfirmRemove
        }, null, 8, ["title", "question-html", "position", "onConfirm", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}